<template>
    <el-container style="height: calc(100vh - 52px)">
        <el-header style="height: auto;" class="bg-gray-200 p-3 md:p-5">
            <div class="flex w-full flex-col md:flex-row">
                <!-- 検索部 -->
                <div class="hidden md:block bg-white border-2 border-gray-400 rounded-md p-4">
                    <el-form :model="searchForm" label-width="auto">
                        <div class="grid md:block md:flex gap-4">
                            <el-form-item class="no-margin md:w-20 lg:w-44 xl:w-64"
                                :class="[
                                    loginUserRole === ROLES.SYSTEM ? 'md:w-20' : 'md:w-36',
                                    loginUserRole === ROLES.SYSTEM ? 'lg:w-44' : 'lg:w-64',
                                    '',
                                ]" 
                                v-show="loginUserRole === ROLES.SYSTEM">
                                <OrganizationSelect v-model="searchForm.organization_id" :is-search="true" placeholder="組織を選択" />
                            </el-form-item>

                            <el-form-item class="no-margin"
                                :class="[
                                    loginUserRole === ROLES.SYSTEM ? 'md:w-20' : 'md:w-36',
                                    loginUserRole === ROLES.SYSTEM ? 'lg:w-44' : 'lg:w-64',
                                    'xl:w-64',
                                ]">
                                <CategorySelect :organization-id="searchForm.organization_id" :is-search="true"
                                    v-model="searchForm.category_id" placeholder="カテゴリを選択" />
                            </el-form-item>

                            <div class="flex"
                                :class="[
                                    loginUserRole === ROLES.SYSTEM ? 'md:w-20' : 'md:w-36',
                                    loginUserRole === ROLES.SYSTEM ? 'lg:w-44' : 'lg:w-64',
                                    'xl:w-64',
                                ]">
                                <el-form-item class="no-margin flex flex-grow">
                                    <AutoCompleteInput 
                                        v-model="searchForm.material_name" 
                                        placeholder="アイテム名を入力"
                                        storage-key="material-name-history"
                                        :max-history-items="15"
                                        ref="materialNameInput"
                                    />
                                </el-form-item>

                                <el-button class="md:hidden ml-3" type="primary" @click="handleSearchButton" circle>
                                    <el-icon>
                                        <span class="material-symbols-outlined">manage_search</span>
                                    </el-icon>
                                </el-button>
                            </div>

                            <!-- <el-form-item class="lg:w-80">
                                <el-select v-model="searchForm.type" placeholder="タイプを選択">
                                    <el-option label="すべて" :value="ALL" />
                                    <el-option label="1日以内" value="1日以内" />
                                    <el-option label="1日前" value="1日前" />
                                    <el-option label="7日前" value="7日前" />
                                    <el-option label="15日前" value="15日前" />
                                    <el-option label="30日前" value="30日前" />
                                    <el-option label="在庫数" value="在庫数" />
                                </el-select>
                            </el-form-item> -->
                            <el-button class="hidden md:block w-24" type="primary"
                                @click="handleSearchButton">検索</el-button>

                        </div>
                    </el-form>
                </div>

                <el-drawer class="md:hidden bg-gray-200" v-model="drawer" title="検索" direction="ttb" :with-header="false" size="auto">
                    <div class="bg-white border-2 border-gray-400 rounded-md p-4">
                        <el-form :model="searchForm" label-width="auto">
                            <div class="grid md:block md:flex gap-4">
                                <el-form-item class="no-margin md:w-20 lg:w-44 xl:w-64"
                                    :class="[
                                        loginUserRole === ROLES.SYSTEM ? 'md:w-20' : 'md:w-36',
                                        loginUserRole === ROLES.SYSTEM ? 'lg:w-44' : 'lg:w-64',
                                        '',
                                    ]" 
                                    v-show="loginUserRole === ROLES.SYSTEM">
                                    <OrganizationSelect v-model="searchForm.organization_id" :is-search="true" placeholder="組織を選択" />
                                </el-form-item>

                                <el-form-item class="no-margin"
                                    :class="[
                                        loginUserRole === ROLES.SYSTEM ? 'md:w-20' : 'md:w-36',
                                        loginUserRole === ROLES.SYSTEM ? 'lg:w-44' : 'lg:w-64',
                                        'xl:w-64',
                                    ]">
                                    <CategorySelect :organization-id="searchForm.organization_id" :is-search="true"
                                        v-model="searchForm.category_id" placeholder="カテゴリを選択" />
                                </el-form-item>

                                <div class="flex"
                                    :class="[
                                        loginUserRole === ROLES.SYSTEM ? 'md:w-20' : 'md:w-36',
                                        loginUserRole === ROLES.SYSTEM ? 'lg:w-44' : 'lg:w-64',
                                        'xl:w-64',
                                    ]">
                                    <el-form-item class="no-margin flex flex-grow">
                                        <AutoCompleteInput 
                                            v-model="searchForm.material_name" 
                                            placeholder="アイテム名を入力"
                                            storage-key="material-name-history"
                                            :max-history-items="15"
                                            ref="materialNameInput"
                                        />
                                    </el-form-item>

                                    <el-button class="md:hidden ml-3" type="primary" @click="handleSearchButton" circle>
                                        <el-icon>
                                            <span class="material-symbols-outlined">manage_search</span>
                                        </el-icon>
                                    </el-button>
                                </div>

                                <!-- <el-form-item class="lg:w-80">
                                    <el-select v-model="searchForm.type" placeholder="タイプを選択">
                                        <el-option label="すべて" :value="ALL" />
                                        <el-option label="1日以内" value="1日以内" />
                                        <el-option label="1日前" value="1日前" />
                                        <el-option label="7日前" value="7日前" />
                                        <el-option label="15日前" value="15日前" />
                                        <el-option label="30日前" value="30日前" />
                                        <el-option label="在庫数" value="在庫数" />
                                    </el-select>
                                </el-form-item> -->
                                <el-button class="hidden md:block w-24" type="primary"
                                    @click="handleSearchButton">検索</el-button>

                            </div>
                        </el-form>
                    </div>
                </el-drawer>

                <!-- 操作部 -->
                <div class="flex justify-end items-center md:flex-grow">
                    <el-button class="custom-alert-icon-btn md:hidden" type="primary" 
                        @click="drawer = true" circle>
                        <span class="material-symbols-outlined">
                            manage_search
                        </span>
                    </el-button>

                    <el-button class="custom-alert-icon-btn md:hidden" type="primary"
                        @click="handleDelAllButton" circle>
                        <span class="material-symbols-outlined">
                            delete
                        </span>
                    </el-button>
                    <el-button class="hidden md:block w-24" type="primary"
                        @click="handleDelAllButton">全削除</el-button>


                    <el-button class="custom-alert-icon-btn md:hidden" type="primary" 
                        @click="handleExportButton" circle>
                        <span class="material-symbols-outlined">
                            download_2
                        </span>
                    </el-button>
                    <el-button class="hidden md:block w-30" type="primary"
                        @click="handleExportButton">CSVエクスポート</el-button>
                </div>
            </div>
        </el-header>

        <el-mian style="padding-bottom: 20px;">
            <!-- 手机CARD部 -->
            <div class="md:hidden" v-loading="loading" style="height: calc(100vh - 176px)">
                <div class="custom-alert-title flex flex-col">
                    <span>アラート（在庫数　品名　有効期間）</span>
                    <span class="ml-auto">アイテム数: {{ mTotalRecords }}</span>
                </div>
                
                <div style="overflow-y: auto; height: calc(100vh - 226px)">
                    <el-card v-for="item in mTableData" :key="item.id" 
                        style="border: 1px solid #d1d5db; border-radius: 0px"
                        :style="{ backgroundColor: new Date(item.expiration_date) < new Date() ? '#f3f3c1' : '' }">
                        <el-row align="middle">
                            <el-col :span="2">
                                <el-button
                                    class="w-8 h-16"
                                    type="primary" 
                                    style="background-color: #c2dbf0;"
                                    text
                                    bg
                                    @click="handleEditButton(item)">
                                    <span>詳<br>細</span>
                                </el-button>
                            </el-col>

                            <el-col :span="6" class="ml-2" align="middle">
                                <span class="text-6xl" :class="{ 'text-red-500': item.type === '在庫数' }">
                                    {{ item.quantity }}
                                </span>
                            </el-col>

                            <el-col :span="12" class="ml-2">
                                <div>{{ item.material_name }}</div>
                                <el-row align="middle">
                                    <span
                                        class="text-xl font-bold"
                                        :class="{ 'text-red-500': new Date(item.expiration_date) < new Date() }">
                                        {{ item.expiration_date }}
                                    </span>
                                    <span class="material-symbols-outlined cursor-pointer ml-4"
                                        :class="{ 'text-red-500': item.is_received != 1 }"
                                        @click="handleSendButton(item)">
                                        drafts
                                    </span>
                                </el-row>
                            </el-col>

                            <el-col :span="2" class="ml-2" align="right">
                                <span class="material-symbols-outlined cursor-pointer"
                                    @click="handleDeleteButton(item)">
                                    delete
                                </span>
                            </el-col>
                        </el-row>
                    </el-card>
                </div>
            </div>

            <!-- WEB表格部 -->
            <div class="alert-table hidden md:block w-full">
                <el-table :data="mTableData" height="calc(100vh - 230px)" v-loading="loading" :row-class-name="tableRowClassName">
                    <el-table-column label="アラート" width="80" align="center">
                        <template #default="scope">
                            <el-button
                                class="w-12"
                                type="primary" 
                                style="background-color: #c2dbf0;"
                                text
                                bg
                                @click="handleEditButton(scope.row)">
                                <span>詳細</span>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="loginUserRole === ROLES.SYSTEM" prop="organization_name" label="組織" width="200" />
                    <el-table-column prop="department_name" label="部門" width="160" />
                    <el-table-column prop="material_name" label="アイテム名" min-width="400">
                        <template #default="scope">
                            {{ scope.row.material_name }}<br />
                            <span v-if="scope.row.jancode" class="text-sm text-gray-500">
                                （{{ scope.row.jancode }}）
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="category_name" label="カテゴリ" width="160" />
                    <el-table-column prop="user_name" label="宛先" width="160" />
                    <el-table-column prop="storage_date" label="保管日" width="100" align="center" />
                    <el-table-column prop="expiration_date" label="有効期限" width="100" align="center">
                        <template #default="{ row }">
                            <span
                                :class="{ 'text-red-500': new Date(row.expiration_date) < new Date() }">
                                {{ row.expiration_date }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="quantity" label="在庫数" width="66" header-align="center" align="right">
                        <template #default="scope">
                            <span :class="{ 'text-red-500': scope.row.type === '在庫数' }">
                                {{ scope.row.quantity }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="通知" width="52" align="center">
                        <template #default="scope">
                            <span class="material-symbols-outlined cursor-pointer mt-2"
                                :class="{ 'text-red-500': scope.row.is_received != 1 }"
                                @click="handleSendButton(scope.row)">
                                drafts
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="created_date" label="通知日" width="100" align="center">
                        <template #default="{ row }">
                            <span
                                :class="{ 'text-red-500': new Date(row.created_date) < new Date() }">
                                {{ row.created_date.slice(0, 10) }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="削除" width="52" align="center">
                        <template #default="scope">
                            <span class="material-symbols-outlined cursor-pointer mt-2"
                                @click="handleDeleteButton(scope.row)">
                                delete
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页部 -->
            <div class="flex w-full justify-end mt-4">
                <div class="hidden md:block mr-3">
                    <el-pagination v-model:current-page="mCurrentPage" v-model:page-size="mPageSize"
                        :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
                        :total="mTotalRecords" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </div>

                <div class="md:hidden">
                    <el-pagination layout="prev, pager, next" :total="mTotalRecords"
                    @current-change="handleCurrentChange" />
                </div>
            </div>
        </el-mian>
    </el-container>

    <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" style="max-width:800px"
        v-model="dialogFormVisible" title="詳細" align-center>
        <div class="flex-col w-full px-2 justify-center items-center">
            <!-- 右侧表单 -->
            <el-form :model="form" :rules="rules" ref="formRef" label-width="auto">
                <div class="flex flex-col md:flex-row">
                    <div class="w-full md:w-1/2 md:px-2">
                        <el-form-item v-if="loginUserRole === ROLES.SYSTEM" label="組織" prop="organization_id"
                            label-width="100px">
                            <OrganizationSelect v-model="form.organization_id" :disabled="form.add_update === 'update'"
                                @organization-name-change="form.organization_name = $event" placeholder="組織を選択" />
                        </el-form-item>
                        <el-form-item v-if="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)" label="部門" prop="department_id" label-width="100px">
                            <DepartmentSelect :organization-id="form.organization_id" v-model="form.department_id" :disabled="form.add_update === 'update'"
                                @department-name-change="form.department_name = $event" placeholder="部門を選択" />
                        </el-form-item>
                        <el-form-item label="カテゴリ" prop="category_id" label-width="100px">
                            <CategorySelect :organization-id="form.organization_id" v-model="form.category_id" :disabled="form.add_update === 'update'"
                                @category-name-change="form.category_name = $event" placeholder="カテゴリを選択" />
                        </el-form-item>
                        <el-form-item label="アイテム名" prop="material_code" label-width="100px">
                            <MaterialSelect :organization-id="form.organization_id" v-model="form.material_code" :disabled="form.add_update === 'update'"
                                @material-name-change="form.material_name = $event" placeholder="アイテム名を選択" />
                        </el-form-item>
                        <el-form-item label="在庫数" prop="quantity" label-width="100px">
                            <el-input-number v-model="form.quantity" :min="0" :max="999999" />
                        </el-form-item>

                    </div>
                    <div class="w-full md:w-1/2 md:px-2">
                        <el-form-item label="保管日" prop="storage_date">
                            <el-date-picker v-model="form.storage_date" type="date" placeholder="保管日を選択" />
                        </el-form-item>
                        <el-form-item label="有効期限" prop="expiration_date">
                            <el-date-picker v-model="form.expiration_date" type="date" placeholder="有効期限を選択" />
                        </el-form-item>
                        <el-form-item label="保管場所" prop="location">
                            <el-input v-model="form.location" autocomplete="off" placeholder="保管場所を入力" />
                        </el-form-item>
                        <el-form-item label="コメント" prop="comment">
                            <el-input v-model="form.comment" autocomplete="off" placeholder="コメントを入力" />
                        </el-form-item>

                    </div>
                </div>
            </el-form>

            <div class="flex w-full items-center justify-center">
                <el-upload action="#" list-type="picture-card" :auto-upload="false" :on-change="handleImageChange"
                    :on-remove="handleRemove" :limit="3" :on-exceed="handleExceed" :file-list="fileList">
                    <el-icon v-if="fileList.length < 3">
                        <Plus />
                    </el-icon>
                    <template #file="{ file }">
                        <div>
                            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                    <el-icon><zoom-in /></el-icon>
                                </span>
                                <span v-if="!disabled" class="el-upload-list__item-delete"
                                    @click="handleRemove(file)">
                                    <el-icon>
                                        <Delete />
                                    </el-icon>
                                </span>
                            </span>
                        </div>
                    </template>
                </el-upload>
            </div>

        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">キャンセル</el-button>
                <el-button type="primary" @click="handleAddUpdateSubmit(formRef)">
                    確認
                </el-button>
            </div>
        </template>
    </el-dialog>

    <!-- 画像预览 -->
    <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" style="max-width:800px"
        v-model="dialogVisible" align-center>
        <div class="flex justify-center items-center">
            <img w-full :src="dialogImageUrl" alt="Preview Image" />
        </div>
    </el-dialog>
</template>

<script lang="ts">
import { ElMessage, ElMessageBox, ElPagination, ElTable, ElTableColumn, FormInstance, FormRules, UploadFile, UploadInstance } from 'element-plus';
import { defineComponent, nextTick, onMounted, ref } from 'vue';
import OrganizationSelect from '@/components/common/OrganizationSelect.vue';
import CategorySelect from '@/components/common/CategorySelect.vue';
import UserSelect from '@/components/common/UserSelect.vue';
import DepartmentSelect from '@/components/common/DepartmentSelect.vue';
import MaterialSelect from '@/components/common/MaterialSelect.vue';
import AutoCompleteInput from '@/components/common/AutoCompleteInput.vue';
import axios, { AxiosResponse } from 'axios';
import { Bell, Delete, Search, Promotion, ZoomIn, Plus } from '@element-plus/icons-vue';
import { ErrorCode, ResponseData, ResponseStatus, UploadImageResponseData } from '@/components/common/response';
import { getErrorMessage, PageType } from '@/components/common/errorMessage';
import { Operation, SearchRequest } from '@/components/common/request';
import router from '@/router';
import moment from 'moment';
import { ALL, IMG_MAX_SIZE, ROLES, ROUTES } from '@/config/constants';

interface alarmMessagesInfo {
    id: string,
    organization_id: string,
    organization_name: string,
    department_id: string,
    department_name: string,
    user_id: string,
    user_name: string,
    material_code: string,
    material_name: string,
    category_id: string,
    category_name: string,
    inventory_id: string,
    sk: string,
    type: string,
    location: string,
    quantity: number,
    is_received: number,
    created_date: string,
    expiration_date: string,
    storage_date: string,
    images: string,
    comment: string,
}

interface InventoryInfo {
    add_update?: Operation;
    inventory_id: string;
    sk: string;
    material_code: string;
    organization_id: string;
    department_id: string;
    category_id: string;
    category_name: string;
    quantity: number;
    storage_date?: string;
    expiration_date: string;
    location?: string;
    images?: string;
    responsible_person?: string,
    organization_name?: string,
    department_name?: string,
    material_name?: string,
    comment?: string,
    fileList?: UploadFile[],
}

export default defineComponent({
    name: 'MngAlert',
    components: {
        ElTable,
        ElTableColumn,
        ElPagination,
        OrganizationSelect,
        CategorySelect,
        DepartmentSelect,
        UserSelect,
        MaterialSelect,
        AutoCompleteInput,
        Bell,
        Plus,
        ZoomIn,
        Delete,
        Search,
        Promotion,
    },
    setup() {
        const searchForm = ref<any>({
            organization_id: ALL,
            user_id: '',
            type: ALL,
            category_id: ALL,
            material_name: '',
        });

        const form = ref<InventoryInfo>({
            add_update: Operation.unknow,
            inventory_id: '',
            sk: '',
            material_code: '',
            material_name: '',
            organization_id: '',
            organization_name: '',
            category_id: '',
            category_name: '',
            location: '',
            quantity: 0,
            storage_date: '',
            expiration_date: '',
            images: '',
            department_id: '',
            department_name: '',
            comment: '',
        });

        const drawer = ref(false);

        //画像
        const imageList = ref([]);
        const dialogImageUrl = ref<string>('')
        const dialogVisible = ref<boolean>(false);

        const loading = ref<boolean>(true);
        const mTableData = ref<alarmMessagesInfo[]>([]);
        const mCurrentPage = ref<number>(1);
        const mPageSize = ref<number>(10);
        const mTotalRecords = ref<number>(0);
        const size = ref<string>('small');
        const disabled = ref<boolean>(false);
        const background = ref<boolean>(true);

        const dialogFormVisible = ref(false);

        const formRef = ref<FormInstance>();
        const rules = ref<FormRules>({
            organization_id: [
                { required: true, message: '組織を選択してください', trigger: 'change' }
            ],
            department_id: [
                { required: true, message: '部門を選択してください', trigger: 'change' }
            ],
            material_code: [
                { required: true, message: 'コードを選択してください', trigger: 'change' }
            ],
            category_id: [
                { required: true, message: 'カテゴリを選択してください', trigger: 'change' }
            ],
            quantity: [
                { required: true, message: '在庫数を入力してください', trigger: 'blur' },
                { type: 'number', min: 0, message: '在庫数は0以上の数字を入力してください', trigger: 'blur' }
            ],
            storage_date: [
                { required: true, message: '保管日を選択してください', trigger: 'change' }
            ],
            expiration_date: [
                { required: true, message: '失効日を選択してください', trigger: 'change' }
            ]
        });
        // 图片是否改变
        let imageFileChanged: boolean = false;

        // 画像预览
        const imageUrl = ref<string>('')

        const fileList = ref<UploadFile[]>([])

        const loginUserRole = localStorage.getItem('role');
        const loginUserRoleIsHead = localStorage.getItem('is_head') === '1';

        const materialNameInput = ref<any>(null);

        /***** マウント **************************/
        onMounted(() => {
            //  如果没有信息，重新登陆
            if (!loginUserRole) {
                router.push(`/${ROUTES.LOGIN}`);
            }
            getAlarmMessageList();
        });

        /***** ボタン **************************/
        const handleSearchButton = () => {
            drawer.value = false;

            if (materialNameInput.value) {
                materialNameInput.value.submitValue();
            }
            getAlarmMessageList();
        };

        const handleSizeChange = (size: number) => {
            mPageSize.value = size;
            getAlarmMessageList();
        };
        const handleCurrentChange = (page: number) => {
            mCurrentPage.value = page;
            getAlarmMessageList();
        };

        const handleDeleteButton = (row: alarmMessagesInfo) => {
            ElMessageBox.confirm('削除しますか？', '削除', {
                confirmButtonText: '削除',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                deleteAlarmMessage(row.id);
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const handleEditButton = (row: alarmMessagesInfo) => {
            dialogFormVisible.value = true;
            nextTick(async () => {
                formRef.value?.resetFields();
                imageFileChanged = false;
                fileList.value = []

                let inventoryInfo: InventoryInfo | undefined = undefined;
                try {
                    const res: AxiosResponse<ResponseData<InventoryInfo>> = await axios.get(`/api/inventories2/${row.inventory_id}`, {
                        params: {
                            sk: row.sk
                        }
                    });

                    if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                        const { data } = res.data;

                        inventoryInfo = data;
                    }else {
                        ElMessage.error(getErrorMessage(PageType.INVENTORY, res.data.code));
                    }

                } catch (error) {
                    ElMessage.error(getErrorMessage(PageType.INVENTORY));
                } finally{
                    form.value = {
                        add_update: Operation.update,
                        inventory_id: row.inventory_id,
                        sk: row.sk,
                        material_code: inventoryInfo?.material_code || row.material_code,
                        organization_id: inventoryInfo?.organization_id || row.organization_id,
                        department_id: inventoryInfo?.department_id || row.department_id,
                        category_id: inventoryInfo?.category_id || row.category_id,
                        location: inventoryInfo?.location || row.location,
                        quantity: inventoryInfo?.quantity || row.quantity,
                        storage_date: inventoryInfo?.storage_date || row.storage_date,
                        expiration_date: inventoryInfo?.expiration_date || row.expiration_date,
                        images: inventoryInfo?.images || row.images,
                        department_name: inventoryInfo?.department_name || row.department_name,
                        organization_name: inventoryInfo?.organization_name || row.organization_name,
                        material_name: inventoryInfo?.material_name || row.material_name,
                        category_name: inventoryInfo?.category_name || row.category_name,
                        comment: inventoryInfo?.comment || row.comment,
                    };
                    if (form.value.images) {
                        let bufImages = form.value.images.split(',');
                        fileList.value = await getImages(bufImages);
                    } else {
                        fileList.value = []
                    }
                }
            });
        };

        const getImages = async (image_ids: string[]) => {
            var fileLst: UploadFile[] = [];

            for (const image_id of image_ids) {
                const res = await axios.get(`/api/images/download/${image_id}`, { responseType: 'blob' });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === undefined) {
                    const uid = parseInt(image_id);
                    fileLst.push({
                        url: URL.createObjectURL(res.data),
                        uid: uid,
                        name: image_id,
                        raw: res.data,
                        status: 'ready'
                    });
                } else {
                    ElMessage.error('画像情報の取得に失敗しました。');
                }
            }

            return fileLst;
        };

        const handleAddUpdateSubmit = async (formEl: FormInstance | undefined) => {
            if (!formEl) return
            await formEl.validate((valid, fields) => {
                if (valid) {
                    updateInventory(form.value);
                    dialogFormVisible.value = false;
                }
            })
        };

        const updateInventory = async (row: InventoryInfo) => {
            try {
                loading.value = true;

                //画像アップロード
                let images = [];
                if (imageFileChanged && fileList.value.length > 0) {
                    const imgaeInfos = await uploadImages();
                    if (imgaeInfos) {
                        for (const imgaeInfo of imgaeInfos) {
                            images.push(imgaeInfo.id);
                        }
                        form.value.images = images.join(',');
                    } else {
                        ElMessage.error('画像アップロード失敗しました。');
                        return;
                    }
                }

                const res: AxiosResponse<ResponseData<InventoryInfo>> = await axios.put(`/api/inventories2/${row.inventory_id}`, row);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getAlarmMessageList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.INVENTORY, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.INVENTORY));
            } finally {
                loading.value = false;
            }
        };

        const handleSendButton = (row: alarmMessagesInfo) => {
            markAlarmMessageAsReceived(row);
        };

        const handleDelAllButton = () => {
            ElMessageBox.confirm('すべてのアラートを削除する？', '削除', {
                confirmButtonText: '削除',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                deleteAllAlarmMessage();
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        /***** DB 操作 **************************/
        const getAlarmMessageList = async () => {
            loading.value = true;
            try {
                const params: SearchRequest = {
                    page: mCurrentPage.value,
                    limit: mPageSize.value,
                    organization_id: searchForm.value.organization_id === ALL ? '' : searchForm.value.organization_id,
                    user_id: searchForm.value.user_id,
                    type: searchForm.value.type === ALL ? '' : searchForm.value.type,
                    category_id: searchForm.value.category_id === ALL ? '' : searchForm.value.category_id,
                    material_name: searchForm.value.material_name,
                };

                const res: AxiosResponse<ResponseData<alarmMessagesInfo[]>> = await axios.get('/api/alarm-messages/search', { params });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    const { total, totalPages, currentPage, data } = res.data;
                    mTotalRecords.value = total || 0;
                    mTableData.value = data || [];
                } else {
                    ElMessage.error(getErrorMessage(PageType.ALERT, res.data.code));
                }

            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.ALERT));
            } finally {
                loading.value = false;
            }
        };

        const markAlarmMessageAsReceived = async (row: alarmMessagesInfo) => {
            try {
                await sendNotificationToUser(row.user_id);

                const res: AxiosResponse<ResponseData> = await axios.put(`/api/alarm-messages/received/${row.id}`);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getAlarmMessageList();
                    ElMessage.success("アラートメッセージを受信済みとしてマークしました");
                } else {
                    ElMessage.error(getErrorMessage(PageType.ALERT, res.data.code));
                }
            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.ALERT));
            }
        };


        const sendNotificationToUser = async (user_id: string) => {
            try {
                const params = {
                    user_id: user_id,
                    title: 'アラートメッセージ',
                    body: 'アラートメッセージを再送しました',
                };

                const res: AxiosResponse<ResponseData> = await axios.post(`/api/notification/send-notification-to-user`, params);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    ElMessage.success("アラートメッセージを再送しました");
                } else {
                    ElMessage.error(getErrorMessage(PageType.ALERT, res.data.code));
                }
            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.ALERT));
            }
        };


        const deleteAlarmMessage = async (id: string) => {
            try {
                const res: AxiosResponse<ResponseData> = await axios.delete(`/api/alarm-messages/${id}`);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getAlarmMessageList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.ALERT, res.data.code));
                }
            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.ALERT));
            }
        };


        const deleteAllAlarmMessage = async () => {
            try {
                loading.value = true;
                const res: AxiosResponse<ResponseData> = await axios.post('/api/alarm-messages/delete-all');
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    await getAlarmMessageList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.ALERT, res.data.code));
                }
            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.ALERT));
            } finally {
                loading.value = false;
            }
        };

        const uploadImages = async () => {
            if (fileList.value.length > 0) {
                const formData = new FormData()
                for (const tFile of fileList.value) {
                    formData.append('files', tFile.raw || new Blob())
                    //文件过大 100K
                    if (tFile.raw && tFile.raw.size > IMG_MAX_SIZE) {
                        ElMessage.error('ファイルが大きすぎます。');
                        return '';
                    }
                }

                try {
                    const res: AxiosResponse<UploadImageResponseData> = await axios.post('/api/images/upload', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                        ElMessage.success('画像アップロード成功');
                        return res.data.images; // 返回值
                    } else {
                        ElMessage.error('画像アップロード失敗');
                        return '';
                    }
                } catch (error) {
                    ElMessage.error('画像アップロード失敗')
                    return ''; // 返回值
                }
            } else {
                ElMessage.error('ファイルが無効です')
                return ''; // 返回值
            }
        }

        // 画像変更
        const handleImageChange = (file: UploadFile) => {
            if (fileList.value.length >= 4) {
                ElMessage.warning('最大3枚までアップロードできます片。')
                return false
            }
            fileList.value.push(file)
            imageUrl.value = URL.createObjectURL(file.raw || new Blob())
            imageFileChanged = true;
        }

        // 画像削除
        const handleRemove = (file: UploadFile) => {
            // 触发画面重绘
            const index = fileList.value.findIndex(item => item.name === file.name);
            if (index !== -1) {
                fileList.value.splice(index, 1);
                // 触发视图更新
                fileList.value = [...fileList.value];
            }
        }

        // 画像预览
        const handlePictureCardPreview = (file: UploadFile) => {
            dialogImageUrl.value = file.url || ''
            dialogVisible.value = true
        }

        const handleExceed = (files: File[]) => {
            //ElMessage.warning(`最多只能上传4张图片。当前选择了 ${files.length} 张图片，已有 ${fileList.value.length} 张图片。`)
            ElMessage.warning('最大3枚までアップロードできます。')
        }

        const exportAlarmMessage = async () => {
            try {
                const res: AxiosResponse<any> = await axios.post(`/api/alarm-messages/export`, {
                    responseType: 'blob'  // 设置响应类型为 blob
                });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === undefined) {
                    // 创建 Blob 对象并触发文件下载
                    const bom = '\uFEFF'; // UTF-8 BOM
                    const blob = new Blob([bom + res.data], { type: 'text/csv;charset=utf-8;' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = 'アラート管理_' + moment(new Date().toISOString()).format('YYYYMMDDHHmmss') + '.csv';  // 指定下载的文件名
                    link.click();
                } else {
                    ElMessage.error('CSVエクスポート失敗しました。');
                }
            }
            catch (error) {
                ElMessage.error('CSVエクスポート失敗しました。');
            }
        };

        const handleExportButton = () => {
            ElMessageBox.confirm('アラート情報をエクスポートしますか？', 'CSVエクスポート', {
                confirmButtonText: 'エクスポート',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                exportAlarmMessage();
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const tableRowClassName = ({row, rowIndex} : { row: alarmMessagesInfo, rowIndex: number }) => {
            if (new Date(row.expiration_date) < new Date()) {
                return 'warning-row'
            } else {
                return ''
            }
        }

        return {
            loginUserRole,
            loginUserRoleIsHead,
            searchForm,
            mTableData,
            loading,
            mCurrentPage,
            mPageSize,
            mTotalRecords,
            size,
            disabled,
            background,
            form,
            dialogFormVisible,
            handleAddUpdateSubmit,
            formRef,
            rules,
            imageUrl, 
            handleSearchButton,
            handleDeleteButton,
            handleSendButton,
            handleSizeChange,
            handleCurrentChange,
            handleDelAllButton,
            handleImageChange,
            handleEditButton,
            handleRemove,
            handlePictureCardPreview,
            fileList,
            handleExceed,
            handleExportButton,
            dialogImageUrl,
            dialogVisible,
            ROLES,
            ALL,
            tableRowClassName,
            materialNameInput,
            drawer,
        }
    }
});
</script>

<style>
    .el-table .warning-row {
    --el-table-tr-bg-color: #f3f3c1;
    }
</style>